import React from "react";
import { Link } from "react-router-dom";
import ctaCardBg from "../../assets/img/bg/cta_bluecard_bg.jpg";

export const CtaAreaTwo = () => {
  return (
    <>
      <section className="features-area-five pt-120 pb-90">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-8">
              <div className="section-title text-center mb-50">
                <span className="sub-title">Where We Work</span>
                <h2 className="title">Serving Surrey and Nearby Cities</h2>
                <p>
                  We work with businesses across Surrey, including Newton,
                  Fleetwood, Guildford, Cloverdale and South Surrey, plus Delta,
                  Langley and White Rock.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-area cta-area-about">
        <div className="container">
          <div
            className="cta-inner-wrap"
            style={{ backgroundImage: `url(${ctaCardBg})` }}
          >
            <div className="row align-items-center">
              <div className="col-lg-9">
                <div className="cta-content">
                  <div className="cta-info-wrap">
                    <div className="icon">
                      <i className="flaticon-phone-call"></i>
                    </div>
                    <div className="content">
                      <span>Not Sure Where Your Books Stand?</span>
                      <a href="tel:0123456789">[604-XXX-XXXX]</a>
                    </div>
                  </div>
                  <h2 className="title">
                    Book Your Free 20-Minute Books Health Check
                  </h2>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="cta-btn text-end">
                  <Link to="/contact" className="btn">
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
